import React, { FC, useEffect, useState } from "react"
import { AuthProvider } from "./authContext"
import { useCookies } from "react-cookie"
import {
  adLogin,
  aliasLogin,
  aliasLogout,
  appWindowReload,
  initiateLogin,
  logout,
  resetMessageHandler,
  resetSubmitHandler,
} from "./functions/"
import { updateUserAvatar } from "./functions/updateUserAvatar"
import { agent } from "../../../services/api.service"
import { adLogout } from "./functions/adLogout"

const Auth: FC = ({ children }) => {
  const [cookies, setCookie, removeCookie] = useCookies(["hallenToken"])
  const [state, setState] = useState({
    authenticated: false,
    message: {
      text: "",
      variant: "",
    },
    user: {
      username: "",
      userId: "",
      roleId: "",
      avatar: "",
    },
    employeeDetails: {
      employeeId: 0,
      employeeName: "",
      employeeNumber: 0,
      employeeNameNumber: "",
      firstName: "",
      lastName: "",
    },
    rules: [],
    loading: true,
    aliasLoading: false,
    aliased: false,
    isAdUser: false,
    position: {},
    isForbidden: false,
  })

  const providerValue = {
    ...state,
    setState: setState,
    adLogin: adToken => adLogin(adToken, setCookie, setState, logout),
    aliasLogin: username => aliasLogin(username, setState),
    aliasLogout: () => aliasLogout(setState, removeCookie),
    updateUserAvatar: avatar => updateUserAvatar(avatar, setState),
    initiateLogin: (e, email, password, isAdminLogin = false) =>
      initiateLogin(
        e,
        email,
        password,
        setState,
        setCookie,
        logout,
        removeCookie,
        isAdminLogin
      ),
    logout: () => logout(removeCookie, setState),
    adLogout: () => adLogout(removeCookie, setState),
    resetMessageHandler: () => resetMessageHandler(setState),
    resetSubmitHandler: (e, username) =>
      resetSubmitHandler(e, username, setState),
  }

  useEffect(() => {
    appWindowReload(cookies, setState, removeCookie)
  }, [])

  React.useMemo(() => {
    // Superagent Response Interceptor
    let AuthIntercept = require("superagent-intercept")((err, res) => {
      if (err && err.response && err.response.status === 403) {
        // TEMPORARY HOTFIX: FiftyThirteen's backend is being blocked by a
        // legacy Incapsula/WAF configuration (known issue, tracked separately
        // with Andres/Krunal). That block returns a 403 which this interceptor
        // was treating as a session timeout, showing a false "Authentication
        // Error" modal even though the TimeCard save itself succeeds.
        // This carves out ONLY these specific calls so every other 403 in the
        // app still behaves exactly as before. Remove this carve-out once the
        // Incapsula/Application Gateway fix is confirmed in place.
        const requestUrl = err.response.request?.url || err.response.req?.url || res?.request?.url || ''
        const isFiftyThirteenCall =
          requestUrl.includes('FiftyThirteenDropdowns') ||
          requestUrl.includes('FiftyThirteenTieIn')

        if (isFiftyThirteenCall) {
          console.warn('FiftyThirteen call blocked (403) — suppressing auth modal (temporary hotfix)', requestUrl)
        } else {
          setState(prevState => ({ ...prevState, isForbidden: true }))
        }
      }
    })
    agent.use(AuthIntercept)
  }, [])

  return <AuthProvider value={providerValue}>{children}</AuthProvider>
}

export default Auth